<template>
  <div>
    <div slot="title">
      <h2 class="label-black">Mis Resultados</h2>
    </div>
    <div slot="main">
      <div class="container-fluid">
        <div class="row">
          <div class="col-12 table-responsive" style="margin-top:50px;">
            <table class="table table-striped table-light table-hover table-sm" id="tablaCuestionarios">
              <thead class="thead-custom">
                <tr>
                  <th class="text-center">Id de Solicitud</th>
                  <th class="text-center">Periodo de evaluación</th>
                  <th class="text-center">Fecha de entrega</th>
                  <th class="text-center">Puestos</th>
                  <th class="text-center">Departamento</th>
                  <th class="text-center">Estatus de evaluación</th>
                  <th class="text-center">Acciones</th>
                </tr>
              </thead>
              <tbody class='text-dark'>
                <tr v-for='evaluacion in evaluaciones'>
                  <td># {{evaluacion.SolicitudEvaluacionId}}</td>
                  <td>{{evaluacion.FechaInicioPeriodoEvaluacionString}} - {{evaluacion.FechaFinPeriodoEvaluacionString}}</td>
                  <td>{{evaluacion.FechaLimiteEntregaString}}</td>
                  <td>{{evaluacion.Puesto}}</td>
                  <td>{{evaluacion.Seccion}} - {{evaluacion.Departamento}}</td>
                  <td>{{evaluacion.Estatus}}</td>
                  <td class='d-flex justify-content-around'>
                    <i class='fa fa-info-circle' @click='verDetalles(evaluacion.EvaluacionId,evaluacion.SolicitudEvaluacionId)' title="Ver Detalles"/>
                    <!-- <i class='fa fa-print' /><i class='fa fa-print' /><i class='fa fa-info-circle' @click='verDetalles(evaluacion.EvaluacionId,evaluacion.SolicitudEvaluacionId)' title="Ver Detalles"/> -->
                  </td>
                </tr>
                <tr v-if="evaluaciones.length == 0"><td colspan="8">No se encontraron evaluaciones pendientes</td></tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import comun from '@/../static/js/comun'
  import enumeraciones from '@/../static/js/enumeraciones'
  import api from '@/../static/js/api'
  import axios from 'axios'
  import Vue from 'vue'
  import store from '@/store/index'

  export default {
    data() {
      return {
        evaluaciones: []
      }
    },
    components: {

    },
    methods: {
      buscarCuestionarios: function () { //Retorna una lista de evaluaciones pendientes en base a ciertos filtros
        //Carga la información necesaria para hacer la petición
        var peticion = {
          "esPrueba": false
        };
        comun.SeEstaCargandoInformacion(true);
        axios.post(api.conexion + api.SISEVA.funcion.GetMisResultados, peticion, comun.CrearElHeaderDeAutorizacion(store.state.Login_AutorizacionOriginal)).then(response => {
          if (response.data.SiHayError == false) {//En caso de que la petición sea exitosa
            this.evaluaciones = response.data.Evaluaciones//Carga los datos necesarios
          }
          else {
            console.error(response);
            comun.mensajeDeAlerta(response.data.Error.Mensaje, null, null)
          }
          comun.SeEstaCargandoInformacion(false);
        }).catch(e => {
          console.error("encontre un error " + e);
          comun.mensajeDeAlerta(comun.mensajeDeError(enumeraciones.error.E500), null, null)
        });

      },
      verDetalles: function (idEvaluacion, idSolicitud) {
        //Redirige a la página SISEVA/DetallesEvaluado, para modificar la evaluación que se haya seleccionado, se envia el id de evaluación como parametro
        this.$router.push({
        name: 'ResultadoPersonal',
        params: { idEvaluacion: idEvaluacion, infoPersona: this.infoPersona }
    })
      }
    },
    mounted: function () {
      this.buscarCuestionarios();
    }

  }

</script>

<style scoped>
  .thead-custom {
    background-color: #004746;
    color: white;
  }
  .custom-area {
        background-color: #7e7f74;
    }
    .label-black {
        color: black;
    }
    .btn-custom {
        background-color: #004746;
        color: white;
    }
</style>



// WEBPACK FOOTER //
// src/components/SISEVA/Evaluaciones/Evaluacion/MisResultados.vue